import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ja from './locales/ja.json';

// Get stored language or detect from browser
const getInitialLanguage = () => {
  // First check localStorage for user preference
  const stored = localStorage.getItem('language');
  if (stored) return stored;
  
  // Detect browser language
  const browserLang = navigator.language || navigator.userLanguage;
  
  // Check if browser language is Japanese (ja, ja-JP, etc.)
  if (browserLang && browserLang.toLowerCase().startsWith('ja')) {
    return 'ja';
  }
  
  // Default to English
  return 'en';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ja: { translation: ja }
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
